import { useQuery } from '@tanstack/react-query'
import { getConversations } from '~/services/conversationService'
import { QueryKeys } from '~/services/queryClient'
import { Conversation } from '~/types/Conversations'
import { serverSideProps } from '~/utils/ssr'
import { getConversationsPaginated,ConversationsResponse } from '~/services/conversationService'
import { useInfiniteQuery } from '@tanstack/react-query'


export function useConversations() {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    error,
    status,
  } = useInfiniteQuery<ConversationsResponse, Error>({
    queryKey: QueryKeys.Conversations,
    queryFn: ({ pageParam = 0 }) => getConversationsPaginated(pageParam as number),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (!lastPage || !lastPage.has_more) {
        return undefined;
      }
      return lastPage.next_cursor;
    },
    initialData: {
          pages: [
            {
              data: [],
              next_cursor: null,
              has_more: false,
            },
          ],
          pageParams: [0],
        }
  });
  const conversations = data
    ? data.pages.flatMap((page) => page.data || [])
    : [];

  return {
    conversations,
    fetchNextPage,
    hasNextPage,
    isFetching,
    error,
    status,
  };
}